export class UserState {

  id?: string | null;
  email?: string | null;
  firstName?: string | null;
  alias?: string | null;
  lastName?: string | null;
  assigned?: boolean | null;
  active?: boolean | null;
  accessSent?: Date | null;
  lastLogin?: Date | null;
  companyName?: string | null;
  isTrial?: boolean | null;
  endDate?: Date | null;
  roleIds?: string[] | null;
}

export class UserStateChecked extends UserState {
  checked?: boolean | null = false;

}
